import React from 'react';
import { Header, Button, Grid, Segment, Loader, Table, Icon, Form, Popup, Tab, Responsive } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';

import SimpleTwoColumnTableRow from '../../../StudentPersonalInfo/SimpleTwoColumnTableRow';
import EditPersonInfo from './EditPersonInfo';

import { addContact, deleteContact } from '../../../StudentPersonalInfo/request';
import ContactFormEditable from '../../../util/ContactFormEditable';
import request from '../../../util/request';
import { FormattedMessage } from 'react-intl';
import { FiltersOnStyle, IconHeader, RightHeaderWithButton } from '../../../Professor/ProfessorInputGrades/css';
import PreviousEducations from '../../../StudentService/StudentCreateAndEdit/PreviousEducations';
import AccountInfo from '../../../StudentPersonalInfo/AccountInfo';
import { extractFileNameFromHeaders } from '../../../DegreeDocumentPrint/util/util';
import download from 'downloadjs';
import StaffRole from '../../../Professor/StaffRole';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class EmployeeInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            person: {},
            employee: {},
            previousEducations: [],

            contactEditMode: false,
            personData: {},
            loading: true,
            editInfo: false,
            main: null,

            addTitleMode: false,

            contactTypes: [],
            contacts: [],

            editAcademicInfo: false,
            addNewContactInfo: false


        };

        this.handleInputChange = this.handleInputChange.bind(this);

        this.getPreviousEducations = this.getPreviousEducations.bind(this);
        this.switchPreviousEducationEditMode = this.switchPreviousEducationEditMode.bind(this);
        this.onDeletePreviousEducation = this.onDeletePreviousEducation.bind(this);
        this.onAddNewPreviousEducation = this.onAddNewPreviousEducation.bind(this);
        this.onEditPreviousEducation = this.onEditPreviousEducation.bind(this);

        this.switchContactAddMode = this.switchContactAddMode.bind(this);
        this.updateContacts = this.updateContacts.bind(this);
        this.onAddNewContact = this.onAddNewContact.bind(this);
        this.onDeleteContact = this.onDeleteContact.bind(this);
        this.onEditContact = this.onEditContact.bind(this);
        this.switchContactEditMode = this.switchContactEditMode.bind(this);

        this.switchAccountMailEditMode = this.switchAccountMailEditMode.bind(this);
        this.editAccountMail = this.editAccountMail.bind(this);
        this.fetchAccountMail = this.fetchAccountMail.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.setState({
            person: JSON.parse(localStorage.getItem('person')),
            employee: JSON.parse(localStorage.getItem('employee')),
            main: localStorage.getItem('main') === 'true',
        });

        request.fetchContactTypes()
            .then(contactTypes => this.setState({ contactTypes }));

        this.updateContacts();
    }
    componentDidMount() {
        localStorage.setItem('employeeId', this.state.employee.id);
        this.getPreviousEducations();
        this.fetchAccountMail();
    }

    getPreviousEducations() {
        let personId = JSON.parse(localStorage.getItem('person')).id;
        axios.get(`previous-education/${personId}`)
            .then(res => this.setState({ previousEducations: res.data.reverse() }));
    }

    getPerson(jmbg) {
        let obj = {
            jmbg
        };
        axios.post('hr/get-person-by-jmbg/', { ...obj })
            .then(res => {
                localStorage.setItem('person', JSON.stringify(res.data[0]));
                this.setState({
                    person: JSON.parse(localStorage.getItem('person'))
                });
            });
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    onDeleteContact(contactId) {
        deleteContact(contactId, 'hr', { id: this.state.person.id })
            .then(res => { toast('Kontakt je uspješno izbrisan.'); this.updateContacts(); });
    }


    onEditContact(requestBody) {
        axios.put('employees/change-contact', { ...requestBody })
            .then(res => {
                toast('Kontakt je uspješno izmijenjen.');
                this.updateContacts();
            })
            .catch(err => {
                toast('Došlo je do greške! Kontakt nije uspješno izmijenjen.');
            });
    }

    onAddNewContact(contact) {
        addContact(contact, this.state.contactTypes, 'hr', this.state.person.id)
            .then(res => { toast('Dodavanje kontakta uspješno izvršeno.'); this.updateContacts(); });
    }

    updateContacts() {
        let obj = {
            id: JSON.parse(localStorage.getItem('person')).id
        };

        axios.post('employees/contacts/', { ...obj })
            .then(res => {
                this.setState({ contacts: res.data });
            })
            .catch(err => {
                console.log('Failed to fetch employee contacts.');
            });
    }
    switchContactAddMode() {
        this.setState(prevState => ({ contactAddMode: !prevState.contactAddMode }));
    }

    switchContactEditMode() {
        this.setState(prevState => ({ contactEditMode: !prevState.contactEditMode }));
    }

    switchPreviousEducationEditMode() {
        request.fetchInstitutionTypes()
            .then(institutionTypes => this.setState({ institutionTypes }));

        request.fetchEducationLevels()
            .then(educationLevels => this.setState({ educationLevels }));
        this.setState(prevState => ({ previousEducationEditMode: !prevState.previousEducationEditMode }));
    }

    onAddNewPreviousEducation(prevEducation) {
        axios.post('previous-education/add', { ...prevEducation })
            .then(res => {
                toast('Uspješno ste dodali novo prethodno obrazovanje.');
                this.getPreviousEducations();
            })
            .catch(err => {
                toast('Došlo je do greške. Prethodno obrazovanje nije dodato.');
                console.log('Failed to add previous education.');
            });
    }
    onDeletePreviousEducation(previousEducationId) {
        if (this.state.previousEducations && this.state.previousEducations.length === 1) {
            toast('Nenastavno osoblje mora imati podatke o prethodnom obrazovanju. Dodajte novo kako bi izbrisali postojoće.');
        } else {
            axios.delete(`previous-education/delete/${previousEducationId}`)
                .then(res => {
                    toast('Uspješno ste izbrisali prethodno obrazovanje.');
                    this.getPreviousEducations();
                })
                .catch(err => {
                    toast('Došlo je do greške. Prethodno obrazovanje nije obrisano.');
                    console.log('Failed to add previous education.');
                });
        }
    }

    onEditPreviousEducation(prevEducation) {
        axios.put('previous-education/edit', { ...prevEducation })
            .then(res => {
                toast('Uspješno ste izmijenili prethodno obrazovanje.');
                this.getPreviousEducations();
            })
            .catch(err => {
                toast('Došlo je do greške. Prethodno obrazovanje nije izmijenjeno.');
                console.log('Failed to add previous education.');
            });
    }

    fetchAccountMail() {
        let obj = {
            id: JSON.parse(localStorage.getItem('person')).id
        };
        axios.post('/user/get-user-data/', { ...obj })
            .then(res => {
                // eslint-disable-next-line no-unused-expressions
                res.data ?
                    this.setState({ accountMail: res.data.eMail, username: res.data.username, loaded: true })
                    : this.setState({ accountMail: null, loaded: true });
            }).catch(err => {
                this.setState({ accountMail: null, loaded: true });
            });
    }

    switchAccountMailEditMode() {
        this.setState({ editAccountMail: !this.state.editAccountMail });
    }

    editAccountMail(accountMail) {
        axios.put(`user/edit-user-mail/${JSON.parse(localStorage.getItem('person')).id}/`, accountMail)
            .then((res) => {
                this.fetchAccountMail();
                this.switchAccountMailEditMode();
                toast('Uspješno ste izmijenili e-mail!');
            })
            .catch(err => {
                toast('Došlo je do greške! Izmjena e-maila nije izvršena.');
            });
    }

    render() {
        const {
            employee, person, accountMail, username, loaded,
            editAccountMail
        } = this.state;
        if (this.state.editInfo) {
            return (
                <div><EditPersonInfo
                    person={this.state.person}
                    back={() => this.setState({ editInfo: false })}
                    getPerson={(jmbg) => { this.setState({ editInfo: false }); this.getPerson(jmbg); }}
                /></div>);
        }
        return (
            <div >
                <Grid columns={2} className="stackable" >
                    <Grid.Column >
                        <Segment.Group >
                            <Segment>
                                <Header as="h3">
                                    {(localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:' && (this.state.main || localStorage.getItem('associate') === 'true')) &&


                                    <Header style={IconHeader} floated="right" >
                                        <Icon />
                                        <Icon link circular basic="true" floated="right" name="pencil" color="green" onClick={() => this.setState({ editInfo: true })} />
                                    </Header>

                                    }
                                    Lični podaci

                                </Header>
                            </Segment>
                            <Segment>
                                <Table celled size="small" unstackable compact>
                                    <Table.Header>
                                        <Table.Row>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>

                                        {/* <SimpleTwoColumnTableRow */}
                                        {/*    name="Korisničko ime" */}
                                        {/*    keyName="username" */}
                                        {/*    value={person.user ? person.user.username : '-'} */}
                                        {/* /> */}
                                        <SimpleTwoColumnTableRow
                                            name="Ime"
                                            keyName="name"
                                            value={person.firstName}
                                        />
                                        <SimpleTwoColumnTableRow
                                            name="Prezime"
                                            keyName="lastName"
                                            value={person.lastName}
                                        />
                                        {person.gender && person.gender.name === 'ženski' && <SimpleTwoColumnTableRow
                                            name="Djevojačko prezime"
                                            keyName="maidenName"
                                            value={person.maidenName}
                                        />}
                                        <SimpleTwoColumnTableRow
                                            name="JMBG"
                                            keyName="jmbg"
                                            value={person.jmbg}
                                        />
                                        <SimpleTwoColumnTableRow
                                            name="Pol"
                                            keyName="gender"
                                            value={person.gender ? person.gender.name : ''}
                                        />
                                        <SimpleTwoColumnTableRow
                                            name="Datum rođenja"
                                            keyName="dateOfBirth"
                                            value={person.dateOfBirth ? moment(person.dateOfBirth).format('D. M. YYYY.') : ''}
                                        />
                                        <SimpleTwoColumnTableRow
                                            name="Mjesto rođenja"
                                            keyName="placeOfBirth"
                                            value={(person.placeOfBirth ? person.placeOfBirth.name ? person.placeOfBirth.name : '' : '')
                                                    + (person.placeOfBirth ? person.placeOfBirth.country ? ', ' + person.placeOfBirth.country.name : '' : '')
                                            }
                                        />
                                        <SimpleTwoColumnTableRow
                                            name="Nacionalnost"
                                            keyName="nationality"
                                            value={person.nationality ? person.nationality.name : ''}
                                        />
                                        <SimpleTwoColumnTableRow
                                            name="Ime i prezime oca"
                                            keyName="father"
                                            value={person.father ? person.father.firstName + ' ' + person.father.lastName : ''}
                                        />
                                        <SimpleTwoColumnTableRow
                                            name="Ime i prezime majke"
                                            keyName="mother"
                                            value={person.mother ? person.mother.firstName + ' ' + person.mother.lastName : ''}
                                        />
                                        <SimpleTwoColumnTableRow
                                            name="Prebivalište"
                                            keyName="residence"
                                            value={(person.residence ? person.residence.place ? person.residence.place.name : '' : '')
                                                + (person.residence ? person.residence.street ? ', ' + person.residence.street : '' : '')}
                                        />
                                        <SimpleTwoColumnTableRow
                                            name="Boravište"
                                            keyName="currentResidence"
                                            value={(person.currentResidence ? person.currentResidence.place ? person.currentResidence.place.name : '' : '')
                                            + (person.currentResidence ? person.currentResidence.street ? ', ' + person.currentResidence.street : '' : '')}
                                        />

                                    </Table.Body>
                                </Table>
                            </Segment>
                        </Segment.Group>

                    </Grid.Column>
                    <Grid.Column >
                        <Segment.Group>
                            <Segment>
                                <Header as="h3"><FormattedMessage id="student.accountInfo" />
                                    { username ? localStorage.getItem('activeRole').substr(0, 8) !== 'Asistent' && <Header style={IconHeader} floated="right" >
                                        <Icon />
                                        <Icon
                                            link
                                            circular
                                            basic="true"
                                            floated="right"
                                            name={this.state.editAccountMail ? 'close' : 'pencil'}
                                            color={this.state.editAccountMail ? null : 'green'}
                                            onClick={this.switchAccountMailEditMode}
                                        />
                                    </Header> :
                                        loaded && (localStorage.getItem('activeRole').substr(0, 9) === 'HR admin:' || (localStorage.getItem('main') === 'true' || localStorage.getItem('associate') === 'true')) &&
                                        <Header style={IconHeader} floated="right">
                                            <Popup
                                                content="Generiši pristupne podatke"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        onClick={() => {
                                                            axios({
                                                                method: 'post',
                                                                url: `generate-users/employee/${localStorage.getItem('organizationalUnitEmployeeId')}/`,
                                                                responseType: 'blob',
                                                            })
                                                                .then((res) => {
                                                                    this.fetchAccountMail();
                                                                    const fileName = extractFileNameFromHeaders(res.headers);
                                                                    download(res.data, fileName);
                                                                    toast('Uspješno ste generisali pristupne podatke.');
                                                                })
                                                                .catch(err => {
                                                                    if (err.response.data === 'Student is dropped out!') {
                                                                        toast('Generisanje pristupnih podataka nije moguće za ispisane studente.');
                                                                    } else if (err.response.data === 'Student is graduated!') {
                                                                        toast('Generisanje pristupnih podataka nije moguće za studente koji su diplomirali.');
                                                                    } else if (err.response.data === 'Student is locked!') {
                                                                        toast('Generisanje pristupnih podataka nije moguće za zaključane studente.');
                                                                    } else if (err.response.data === 'Student already have an account!') {
                                                                        toast('Student već ima pristupne podatke.');
                                                                    } else if (err.response.data === 'Student switched to new study program!') {
                                                                        toast('Student je prešao na novi studijski program.');
                                                                    } else if (err.response.data.text === 'Student is not enrolled in current academic year!') {
                                                                        toast('Generisanje pristupnih podataka nije moguće za studente koji nisu upisani u trenutnu akademsku godinu.');
                                                                    } else {
                                                                        toast('Došlo je do greške! Pristupni podaci nisu generisani.');
                                                                    }
                                                                });
                                                        }}
                                                        size="small"
                                                        style={FiltersOnStyle}
                                                        basic
                                                        color="blue"
                                                        fluid
                                                    >
                                                        Pristupni podaci
                                                    </Button>}
                                            />
                                        </Header>
                                    }
                                </Header>
                            </Segment>
                            <Segment>
                                <AccountInfo
                                    accountMail={accountMail}
                                    username={username}
                                    editAccountMailFlag={editAccountMail}
                                    editAccountMail={this.editAccountMail}
                                />
                            </Segment>
                        </Segment.Group>
                        {localStorage.getItem('academicStaff') === 'false' &&
                        <Segment.Group>
                            <Segment clearing>
                                <Header as="h3">
                                    {(localStorage.getItem('activeRole').substr(0, 9) !== 'HR admin:' && (this.state.main || localStorage.getItem('associate') === 'true')) && <Header style={IconHeader} floated="right" >
                                        <Icon />
                                        <Icon link circular basic="true" floated="right" name={this.state.previousEducationEditMode ? 'close' : 'pencil'} color={this.state.previousEducationEditMode ? null : 'green'} onClick={this.switchPreviousEducationEditMode} />
                                    </Header>}
                                    Prethodno obrazovanje

                                </Header>
                                {this.state.previousEducationEditMode &&
                                <PreviousEducations
                                    noSegment
                                    institutionTypes={this.state.institutionTypes}
                                    educationLevels={this.state.educationLevels}
                                    onAddNewPreviousEducation={this.onAddNewPreviousEducation}
                                    previousEducations={this.state.previousEducations}
                                    onDeletePreviousEducation={this.onDeletePreviousEducation}
                                    onEditPreviousEducation={this.onEditPreviousEducation}
                                />
                                }
                            </Segment>
                            {!this.state.previousEducationEditMode && <Segment clearing>
                                {(this.state.previousEducations && this.state.previousEducations.length !== 0) ? <Table celled size="small" unstackable compact>
                                    <Table.Header>
                                        <Table.Row />
                                    </Table.Header>
                                    <Table.Body>{this.state.previousEducations.map(el =>
                                        (<SimpleTwoColumnTableRow
                                            name={el.institution.type ? el.institution.type.name.substring(0, 1).toUpperCase() + el.institution.type.name.substring(1) : ''}
                                            keyName="institution"
                                            value={el.educationLevel ? el.institution.name + ' | ' + el.educationLevel.name : el.institution.name}
                                        />
                                        ))}
                                    </Table.Body>
                                </Table> : 'Nema podataka o prethodnom obrazovanju.'}
                            </Segment>}
                        </Segment.Group>}

                        <Segment.Group>
                            <Segment>
                                <Header as="h3">
                                    Kontakt informacije
                                    <Header style={IconHeader} floated="right" onClick={this.switchContactEditMode}>
                                        <Header style={IconHeader} floated="right" >
                                            <Icon />
                                            <Icon link circular basic="true" floated="right" name={this.state.contactEditMode ? 'close' : 'pencil'} color={this.state.contactEditMode ? null : 'green'} />
                                        </Header>


                                    </Header>
                                </Header>
                            </Segment>
                            <ContactFormEditable
                                contacts={this.state.contacts || []}
                                contactTypes={this.state.contactTypes}
                                onAddNewContact={this.onAddNewContact}
                                onDeleteContact={this.onDeleteContact}
                                onEditContact={this.onEditContact}
                                contactEditMode={this.state.contactEditMode}
                                main={this.state.main}
                            />

                        </Segment.Group>
                       {/*{((localStorage.getItem('academicStaff') === 'true' || localStorage.getItem('associate') === 'true') || localStorage.getItem('activeRole').slice(0, 18) === 'HR admin: Rektorat') &&*/}
                        <Segment.Group>
                            <Segment>
                                <Header as="h3">
                                    Korisničke uloge
                                </Header>
                            </Segment>
                            <Segment>
                                {loaded &&
                                <StaffRole
                                    username={username}
                                    limitAccess={!(localStorage.getItem('main') === 'true' || localStorage.getItem('associate') === 'true')}
                                />
                                }
                            </Segment>
                        </Segment.Group>
                       {/*}*/}
                    </Grid.Column>
                </Grid>
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/profile/Employee/EmployeeInfo.js